import { Environment } from './environment.class';

export const environment: Environment = {
  production: true,
  mockDomaine: 'http://localhost:3000/snackoverflow/api',
  baseUrlSpa: '',
  mouvementEndpoint: 'coordonnees/mouvement',
  mock: false,
  keyPosteCanada: 'bb86-ga49-un89-pw85',
  identifiantProjetPosteCanada: 'caad-prod',
  spinnerTimeout: 90000,
  requestTimeout: 15000,
};
